// @ts-nocheck

import clsx from "clsx";
import type { ComponentProps } from "react";

import type { CardInfoType } from "@features/home-more-about/model";

import { COLORS_VALUES } from "@shared/constants";
import { useImageMaskRef } from "@shared/hooks/use-image-mask-ref";
import { Button } from "@shared/ui/button";
import { Icon } from "@shared/ui/icon";
import { Image } from "@shared/ui/image";
import { Link } from "@shared/ui/link";
import { Heading } from "@shared/ui/typography";

import s from "./card-info.module.scss";

export type CardInfoProps = ComponentProps<"div"> & {
  className?: string;
  card: CardInfoType;
};

export const CardInfo = (props: CardInfoProps) => {
  const { className, card } = props;

  const $imageRef = useImageMaskRef();

  const style: React.CSSProperties & { ["--main-card-color"]: string } = {
    "--main-card-color": COLORS_VALUES[card.mainColor],
  };

  return (
    <div className={clsx(s.root, className)} style={style}>
      <div className={s.top}>
        <div className={s.imageWrapper} ref={$imageRef}>
          {card?.image?.url && (
            <Image
              src={card.image.url}
              alt={card.image?.alternativeText ?? "card image"}
              height="100%"
              className={s.image}
            />
          )}
        </div>
      </div>
      <div className={s.bottom}>
        {card?.title && <p className={s.title}>{card.title}</p>}
        <div className={s.wrapperIcons}>
          {card?.icon?.name && (
            <Icon name={card.icon.name} className={s.icon} />
          )}
          <Icon name="arrow" className={s.iconArrow} />
        </div>
      </div>
      {card?.link && (
        <Link
          href={card.link}
          className={s.link}
          aria-label={card.title ?? undefined}
        >
          &nbsp;
        </Link>
      )}
    </div>
  );
};

CardInfo.displayName = "CardInfo";
